import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoHint } from "../info-hint/info-hint";
export function FieldSectionLabel({ icon: Icon, children, hint, slot }) {
    const label = /*#__PURE__*/ _jsxs("label", {
        className: `flex items-center gap-1.5 text-xs font-medium text-muted-foreground ${slot ? "" : "mb-1"}`,
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: "w-3.5 h-3.5"
            }),
            children,
            hint && /*#__PURE__*/ _jsx(InfoHint, {
                content: hint
            })
        ]
    });
    // Without a slot the label is returned untouched, so every existing caller
    // keeps its exact markup and spacing.
    if (!slot) return label;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-1.5 mb-1",
        children: [
            label,
            /*#__PURE__*/ _jsx("span", {
                className: "flex items-center",
                children: slot
            })
        ]
    });
}

//# sourceMappingURL=FieldSectionLabel.js.map